import React from 'react';
import Modal from 'react-bootstrap/Modal';
import Carousel from 'react-bootstrap/Carousel';

function GameModal({ children, show, handleClose, isMarket = false }) {

    return (
        <Modal
            onHide={handleClose} show={show}>
            <Modal.Header style={{
                color: '#fff',
                backgroundColor: '#eb6d03'
            }} closeVariant='white' closeButton>
                <Modal.Title style={{ fontSize: '24px', }}>Tutorial</Modal.Title>
            </Modal.Header>

            <Modal.Body style={{
                backgroundColor: '#eb6d03'
            }}>
                {!isMarket ? (
                    <Carousel interval={null}>
                        <Carousel.Item>
                            <img className='d-block w-100' src="./tutorial/pcp-tutorial.gif" />
                            <div style={{
                                padding: '20px',
                                marginBottom: '15px'
                            }}>
                                <p style={{
                                    color: "#fff"
                                }}>A primeira etapa é cadastrar o PCP (Planejamento Controle de Produção) da sua indústria.
                                    Toda semana/rodada você envia seu PCP para cada produto que você irá produzir.
                                    O envio do PCP deve ser feito até o último dia da semana.</p>
                            </div>
                        </Carousel.Item>
                        <Carousel.Item>
                            <img className='d-block w-100' src="./tutorial/compra-tutorial.gif" />
                            <div style={{
                                padding: '20px',
                                marginBottom: '15px'
                            }}>
                                <p style={{
                                    color: "#fff"
                                }}>Para produzir precisa comprar insumos. Basta escolher o fornecedor,
                                    selecionar a forma de pagamento e em seguida confirmar. Seu estoque novo será entregue no prazo estipulado pelo fornecedor
                                    escolhido, portanto se organize para não ficar sem estoque para produção em uma nova semana.</p>
                            </div>
                        </Carousel.Item>

                        <Carousel.Item>
                            <img className='d-block w-100' src="./tutorial/prod-tutorial.gif" />
                            <div style={{
                                padding: '20px',
                                marginBottom: '15px'
                            }}>
                                <p style={{
                                    color: "#fff"
                                }}>Sua próxima etapa será a produção dos seus produtos.
                                    Lembrando que para produzir você precisa ter estoque de insumos e ter enviado o PCP.
                                    Basta escolher o produto que desejar, selecionar os turnos de produção e enviar.
                                </p>
                            </div>
                        </Carousel.Item>


                        <Carousel.Item>
                            <img className='d-block w-100' src="./tutorial/neg.industria-tutorial.gif" />
                            <div style={{
                                padding: '20px',
                                marginBottom: '15px'
                            }}>
                                <p style={{
                                    color: "#fff"
                                }}>Para vender seu estoque produzido, vá até a tela de negociação. Escolha o supermercado, e agende uma visita. Envie
                                    a quantidade de cada produto que você deseja vender. Após o envio o supermercado receberá a oferta e aceitará ou não sua proposta,
                                    essa negociação dura no máximo 1 hora. Após esse tempo a visita é cancelada.
                                </p>
                            </div>
                        </Carousel.Item>
                    </Carousel>
                ) : (
                    <Carousel interval={null}>
                        <Carousel.Item>
                            <img className='d-block w-100' src="./tutorial/compra-market-tutorial.gif" />
                            <div style={{
                                padding: '20px',
                                marginBottom: '15px'
                            }}>
                                <p style={{
                                    color: "#fff"
                                }}>Uma industria irá enviar um agendamento de visita com oferta para compra de um ou mais produtos.
                                    Selecione o menu compras, analise a oferta e escolha entre aceitar ou enviar uma contra proposta, lembre-se que há
                                    um limite de tempo na negociação que pode levar no máximo 1 hora.
                                </p>
                            </div>
                        </Carousel.Item>
                        <Carousel.Item>
                            <img className='d-block w-100' src="./tutorial/venda-market-tutorial.gif" />
                            <div style={{
                                padding: '20px',
                                marginBottom: '15px'
                            }}>
                                <p style={{
                                    color: "#fff"
                                }}>Após negociar uma compra de produto em uma indústria. Seu proximo passo é vender seu novo estoque. Basta ir até a tela de Vendas
                                    preencher a quantidade do produto que quer realizar a venda e o seu preço.
                                </p>
                            </div>
                        </Carousel.Item>
                        <Carousel.Item>
                            <img className='d-block w-100' src="./tutorial/relatorio-market-tutorial.gif" />
                            <div style={{
                                padding: '20px',
                                marginBottom: '15px'
                            }}>
                                <p style={{
                                    color: "#fff"
                                }}>Em relátorio semanal, você pode conferir suas últimas jogadas, compras e vendas dos seus produtos.
                                </p>
                            </div>
                        </Carousel.Item>
                    </Carousel>
                )

                }
            </Modal.Body>
        </Modal>
    );
}

export default GameModal;